<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Assurance Transport</h2>
    <p>
      Si vous êtes à la recherche de ce type d'<strong>assurance Transport</strong>, merci de prendre contact avec nous car il existe beaucoup de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Une couverture complète pour les professionnels du transport</h2>
    <p>
      L'assurance transport est essentielle pour protéger votre activité de transporteur routier, que vous exerciez pour le compte d'autrui ou pour votre propre compte.
    </p>
    <p>
      Cette assurance couvre les risques liés à l'exploitation de votre activité de transport : responsabilité civile professionnelle, dommages aux véhicules, protection des marchandises transportées et bien plus encore.
    </p>
  </div>

  <div class="content-section">
    <h2>Qui est concerné par l'assurance transport ?</h2>
    <p>
      Cette assurance s'adresse à tous les professionnels du secteur du transport :
    </p>
    <ul>
      <li>Transporteurs routiers de marchandises (TRM)</li>
      <li>Transporteurs routiers de voyageurs</li>
      <li>Commissionnaires de transport</li>
      <li>Transitaires et organisateurs de transport</li>
      <li>Loueurs de véhicules avec chauffeur (VTC)</li>
      <li>Transporteurs express et messagerie</li>
      <li>Déménageurs professionnels</li>
      <li>Transporteurs frigorifiques</li>
      <li>Transporteurs de matières dangereuses</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>Les garanties essentielles</h2>
    
    <h3>Responsabilité Civile Transporteur</h3>
    <p>
      <strong>Obligatoire</strong> pour tous les transporteurs professionnels, cette garantie couvre votre responsabilité en cas de :
    </p>
    <ul>
      <li>Perte ou avarie des marchandises transportées</li>
      <li>Retard de livraison</li>
      <li>Dommages causés aux tiers lors du chargement/déchargement</li>
      <li>Frais de reconditionnement et de réexpédition</li>
    </ul>

    <h3>Responsabilité Civile Professionnelle</h3>
    <p>
      Protection contre les dommages que vous pourriez causer à des tiers dans le cadre de votre activité professionnelle.
    </p>

    <h3>Assurance Flotte Automobile</h3>
    <p>
      Couverture de l'ensemble de vos véhicules de transport (camions, fourgons, tracteurs, semi-remorques).
    </p>
  </div>

  <div class="content-section">
    <h2>Les garanties complémentaires</h2>
    
    <h3>Perte d'exploitation</h3>
    <p>
      Indemnisation de la perte de chiffre d'affaires en cas d'immobilisation de votre flotte suite à un sinistre.
    </p>

    <h3>Protection juridique transport</h3>
    <p>
      Prise en charge des frais de défense en cas de litige avec un client, un fournisseur ou l'administration.
    </p>

    <h3>Valeur à neuf des véhicules</h3>
    <p>
      Indemnisation au prix d'achat en cas de destruction totale d'un véhicule récent.
    </p>

    <h3>Marchandises transportées</h3>
    <p>
      Couverture spécifique pour les marchandises en cas de vol, incendie ou accident pendant le transport.
    </p>

    <h3>Responsabilité du commissionnaire de transport</h3>
    <p>
      Protection spécifique pour les commissionnaires qui organisent le transport sans l'exécuter eux-mêmes.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Les obligations légales</h2>
    
    <h3>Attestation de capacité professionnelle</h3>
    <p>
      Pour exercer l'activité de transporteur routier, vous devez détenir une attestation de capacité professionnelle délivrée par la DREAL (Direction Régionale de l'Environnement, de l'Aménagement et du Logement).
    </p>

    <h3>Inscription au registre des transporteurs</h3>
    <p>
      Tout transporteur doit être inscrit au registre des transporteurs et commissionnaires de transport.
    </p>

    <h3>Capacité financière</h3>
    <p>
      Vous devez justifier d'une capacité financière minimale :
    </p>
    <ul>
      <li>9 000 € pour le premier véhicule de plus de 3,5 tonnes</li>
      <li>5 000 € par véhicule supplémentaire</li>
      <li>1 800 € pour les véhicules de moins de 3,5 tonnes</li>
    </ul>

    <h3>Assurance obligatoire</h3>
    <p>
      La souscription d'une assurance responsabilité civile transporteur est obligatoire pour obtenir et conserver votre licence de transport.
    </p>
  </div>

  <div class="content-section">
    <h2>Les risques spécifiques au secteur</h2>
    
    <h3>Vol de marchandises</h3>
    <p>
      Le vol de marchandises en transit ou lors de stationnement est un risque majeur. Une garantie spécifique est recommandée, notamment pour les marchandises de valeur.
    </p>

    <h3>Responsabilité limitée par la loi</h3>
    <p>
      Attention : la responsabilité du transporteur routier est limitée par la loi à environ 8,33 euros par kilo de marchandise transportée. Cette indemnisation peut être insuffisante pour des marchandises de valeur.
    </p>

    <h3>Dommages environnementaux</h3>
    <p>
      En cas de transport de matières dangereuses ou polluantes, des garanties spécifiques sont nécessaires pour couvrir les dommages environnementaux.
    </p>

    <h3>Cyber-risques</h3>
    <p>
      La digitalisation du secteur (GPS, logiciels de gestion de flotte, EDI) expose les transporteurs aux cyber-attaques et aux vols de données.
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2>Transport national et international</h2>
    
    <h3>Transport en France métropolitaine</h3>
    <p>
      Couverture standard pour les transports sur le territoire français, régi par le Code des transports français.
    </p>

    <h3>Transport en Europe</h3>
    <p>
      Extension de garantie pour les transports dans l'Union Européenne et les pays limitrophes, selon la Convention CMR (transport routier international).
    </p>

    <h3>Transport hors Europe</h3>
    <p>
      Garanties spécifiques pour les transports intercontinentaux, avec prise en compte des risques géopolitiques et des réglementations locales.
    </p>
  </div>

  <div class="content-section">
    <h2>Types de transport couverts</h2>
    
    <h3>Transport de marchandises générales</h3>
    <p>
      Palettes, cartons, colis divers ne nécessitant pas de conditions particulières.
    </p>

    <h3>Transport frigorifique</h3>
    <p>
      Marchandises sous température dirigée avec garantie spécifique en cas de rupture de la chaîne du froid.
    </p>

    <h3>Transport de matières dangereuses</h3>
    <p>
      Produits chimiques, inflammables, toxiques nécessitant une certification ADR et des garanties renforcées.
    </p>

    <h3>Transport de fonds et objets de valeur</h3>
    <p>
      Protection spécifique pour le transport d'argent, de bijoux, d'œuvres d'art ou de métaux précieux.
    </p>

    <h3>Transport de véhicules</h3>
    <p>
      Porte-voitures et transporteurs de véhicules neufs ou d'occasion.
    </p>

    <h3>Transport exceptionnel</h3>
    <p>
      Convois exceptionnels pour charges lourdes ou surdimensionnées nécessitant des autorisations spéciales.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Gestion des sinistres</h2>
    
    <h3>En cas d'accident</h3>
    <p>
      Procédures à suivre immédiatement :
    </p>
    <ul>
      <li>Sécuriser la zone et alerter les secours si nécessaire</li>
      <li>Établir un constat amiable si possible</li>
      <li>Prendre des photos des dommages</li>
      <li>Contacter votre assureur dans les 5 jours ouvrés</li>
      <li>Remplir une déclaration de sinistre détaillée</li>
    </ul>

    <h3>En cas de vol ou perte de marchandises</h3>
    <ul>
      <li>Déposer plainte auprès de la gendarmerie ou police</li>
      <li>Informer immédiatement le donneur d'ordre</li>
      <li>Déclarer le sinistre à l'assureur sous 48h</li>
      <li>Conserver tous les documents (CMR, lettres de voiture, bons de livraison)</li>
    </ul>

    <h3>Expertise</h3>
    <p>
      Un expert peut être mandaté pour évaluer les dommages et déterminer les responsabilités. Sa mission permet de faciliter l'indemnisation.
    </p>
  </div>

  <div class="content-section">
    <h2>Tarification de l'assurance transport</h2>
    <p>
      Le coût de votre assurance transport dépend de nombreux critères :
    </p>
    <ul>
      <li>Type de transport exercé (national, international, spécialisé)</li>
      <li>Nature des marchandises transportées</li>
      <li>Taille et âge de votre flotte de véhicules</li>
      <li>Chiffre d'affaires annuel</li>
      <li>Historique de sinistralité</li>
      <li>Zone géographique d'activité</li>
      <li>Mesures de prévention mises en place (formation, télématique, sécurisation)</li>
      <li>Montant des franchises choisies</li>
    </ul>
    <p>
      <strong>Conseil Brokins :</strong> Une gestion rigoureuse de votre sinistralité et des investissements dans la prévention (formation des chauffeurs, systèmes de géolocalisation, sécurisation des sites) permettent de négocier de meilleures conditions tarifaires.
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2>Pourquoi choisir Brokins pour votre assurance transport ?</h2>
    <ul>
      <li><strong>Expertise du secteur :</strong> Connaissance approfondie des métiers du transport et de leurs enjeux</li>
      <li><strong>Solutions personnalisées :</strong> Contrats adaptés à votre activité spécifique (messagerie, frigorifique, exceptionnel, etc.)</li>
      <li><strong>Réseau d'assureurs spécialisés :</strong> Partenariats avec les meilleurs acteurs du marché transport</li>
      <li><strong>Accompagnement réglementaire :</strong> Conseil sur vos obligations légales et administratives</li>
      <li><strong>Gestion des sinistres :</strong> Assistance dédiée pour accélérer vos indemnisations</li>
      <li><strong>Optimisation des coûts :</strong> Analyse de votre sinistralité et recommandations pour réduire vos primes</li>
      <li><strong>Couverture internationale :</strong> Solutions pour vos transports en Europe et hors Europe</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Documents nécessaires pour obtenir un devis</h2>
    <p>
      Pour établir une proposition d'assurance transport adaptée, nous aurons besoin de :
    </p>
    <ul>
      <li>Copie de votre licence de transport</li>
      <li>Attestation de capacité professionnelle</li>
      <li>Liste détaillée de vos véhicules (marque, modèle, année, valeur)</li>
      <li>Chiffre d'affaires des 3 dernières années</li>
      <li>Historique de sinistralité sur 5 ans</li>
      <li>Nature des marchandises transportées</li>
      <li>Zones géographiques d'exploitation</li>
      <li>Kbis de votre entreprise</li>
    </ul>
  </div>

  <div class="content-section cta-section">
    <h2>Contactez-nous pour votre assurance transport</h2>
    <p>Nos experts vous accompagnent dans la protection de votre activité de transport</p>
    <button class="btn-primary" routerLink="/contact">Contactez-nous</button>
  </div>
</app-page-layout>
